/**
 * 在该文件中定义常量
 */
//服务器接口根地址（正式版：WAR部署发布版本时用）
const API_SERVICE_SERVER_BASE_URL = "https://bugxapi.chisalsoft.co/"
// const API_SERVER_BASE_URL = "http://bugx.co:8769/service/server/" //war部署，不再使用网关！！！
const API_SERVER_BASE_URL = API_SERVICE_SERVER_BASE_URL
const API_NEWS_SERVER_BASE_URL = "https://bugxnews-admin.chisalsoft.co" //新闻服务端接口，末尾不要带/ !!!
const OSS_BASE_URL = "https://chisal-bugx-sh-release.chisalsoft.co" //OSS根地址
const SOCKET_IO_SERVER = "https://socket-receive.chisalsoft.co"
const SOCKET_PROJECT_CODE = "BugX"//socketio中的项目Code，需要和Server端保持一致

//服务器接口根地址（正式版：JAR部署发布版本时用）
// const API_SERVICE_SERVER_BASE_URL = "http://bugx.co:8766/"
// const API_SERVER_BASE_URL = "http://bugx.co:8769/service/server/"
// const API_SERVER_BASE_URL = API_SERVICE_SERVER_BASE_URL

//服务器接口根地址（开发版：开发本地部署时用）
// const API_SERVICE_SERVER_BASE_URL = "http://192.168.1.137:8766/"
// // const API_SERVER_BASE_URL = "http://127.0.0.1:8769/service/server/"//war部署，不再使用网关！！！
// const API_SERVER_BASE_URL = API_SERVICE_SERVER_BASE_URL
// const API_NEWS_SERVER_BASE_URL = "https://bugxnews-admin.chisalsoft.co" //新闻服务端接口，末尾不要带/ !!!
// const OSS_BASE_URL = "https://chisal-bugx-sh-release.chisalsoft.co" //OSS根地址
// const SOCKET_IO_SERVER = "https://socket-receive.chisalsoft.co"
// const SOCKET_PROJECT_CODE = "BugX"//socketio中的项目Code，需要和Server端保持一致

//155服务器接口根地址（测试155版）
// const API_SERVICE_SERVER_BASE_URL = "http://chisalsoft.f3322.org:10000/bugx-service-server/"
// //const API_SERVER_BASE_URL = "http://192.168.1.155:8769/service/server/"
// const API_SERVER_BASE_URL = API_SERVICE_SERVER_BASE_URL
// const API_NEWS_SERVER_BASE_URL = "http://chisalsoft.f3322.org:10000/bugxnews" //新闻服务端接口，末尾不要带/ !!!
// const OSS_BASE_URL = "https://chisal-bugx-sh-release.chisalsoft.co" //OSS根地址
// const SOCKET_IO_SERVER = "https://socket-receive.chisalsoft.co"
// const SOCKET_PROJECT_CODE = "BugX"//socketio中的项目Code，需要和Server端保持一致

//137 Percy服务器接口根地址（Percy 137连接Demo服务器正式）
// const API_SERVICE_SERVER_BASE_URL = "http://192.168.1.137:8766/"
// //const API_SERVER_BASE_URL = "http://192.168.1.137:8769/service/server/"
// const API_SERVER_BASE_URL = API_SERVICE_SERVER_BASE_URL
// const SOCKET_IO_SERVER = "http://192.168.1.137:9999"
// const SOCKET_PROJECT_CODE = "BugX"//socketio中的项目Code，需要和Server端保持一致

import $store from "./Store"

const ROLE_LIST = [
    {
        value: 'RoleDeveloper',
        label: $store.state.i18n.developer[$store.state.CN_EN]
    }, {
        value: 'RoleProjectManager',
        label: $store.state.i18n.projectManager[$store.state.CN_EN]
    }, {
        value: 'RoleQualityAssurance',
        label: $store.state.i18n.qa[$store.state.CN_EN]
    }, {
        value: 'RoleCustomer',
        label: $store.state.i18n.client[$store.state.CN_EN]
    }
]

const ICODE_TYPE = {
    register: 1,
    resetPwd: 2,
    resetEmail: 3,
    resetPhoneNumber: 4,
    bindAccount: 5,
    unbindAccount: 6,
    alertPassword: 7,
    bindPhoneNumber: 8
}

const ROLE_DEVELOPER = "RoleDeveloper"
const ROLE_PROJECT_MANAGER = "RoleProjectManager"
const ROLE_QUALITY_ASSURANCE = "RoleQualityAssurance"
const ROLE_CUSTOMER = "RoleCustomer"
const Page_Sizes = [10, 15, 20, 30, 50, 100]
const CountryCode = [{"code":86,"name":"中国大陆"},{"code":886,"name":"中国台湾"},{"code":852,"name":"中国香港"},{"code":60,"name":"马来西亚"},{"code":65,"name":"新加坡"},{"code":81,"name":"日本"},{"code":82,"name":"韩国"},{"code":1,"name":"美国"},{"code":1,"name":"加拿大"},{"code":61,"name":"澳大利亚"},{"code":64,"name":"新西兰"},{"code":355,"name":"阿尔巴尼亚"},{"code":54,"name":"阿根廷"},{"code":971,"name":"阿联酋"},{"code":968,"name":"阿曼"},{"code":994,"name":"阿塞拜疆"},{"code":353,"name":"爱尔兰"},{"code":20,"name":"埃及"},{"code":372,"name":"爱沙尼亚"},{"code":244,"name":"安哥拉"},{"code":43,"name":"奥地利"},{"code":853,"name":"中国澳门"},{"code":675,"name":"巴布亚新几内亚"},{"code":1242,"name":"巴哈马"},{"code":970,"name":"巴勒斯坦"},{"code":973,"name":"巴林"},{"code":507,"name":"巴拿马"},{"code":55,"name":"巴西"},{"code":375,"name":"白俄罗斯"},{"code":359,"name":"保加利亚"},{"code":229,"name":"贝宁"},{"code":32,"name":"比利时"},{"code":51,"name":"秘鲁"},{"code":48,"name":"波兰"},{"code":591,"name":"玻利维亚"},{"code":501,"name":"伯利兹"},{"code":226,"name":"布基纳法索"},{"code":240,"name":"赤道几内亚"},{"code":45,"name":"丹麦"},{"code":49,"name":"德国"},{"code":228,"name":"多哥"},{"code":7,"name":"俄罗斯"},{"code":33,"name":"法国"},{"code":63,"name":"菲律宾"},{"code":358,"name":"芬兰"},{"code":238,"name":"佛得角"},{"code":220,"name":"冈比亚"},{"code":1473,"name":"格林纳达"},{"code":995,"name":"格鲁吉亚"},{"code":57,"name":"哥伦比亚"},{"code":506,"name":"哥斯达黎加"},{"code":592,"name":"圭亚那"},{"code":31,"name":"荷兰"},{"code":504,"name":"洪都拉斯"},{"code":253,"name":"吉布提"},{"code":996,"name":"吉尔吉斯斯坦"},{"code":224,"name":"几内亚"},{"code":245,"name":"几内亚比绍"},{"code":241,"name":"加蓬"},{"code":855,"name":"柬埔寨"},{"code":263,"name":"津巴布韦"},{"code":237,"name":"喀麦隆"},{"code":974,"name":"卡塔尔"},{"code":1345,"name":"开曼群岛"},{"code":385,"name":"克罗地亚"},{"code":269,"name":"科摩罗"},{"code":965,"name":"科威特"},{"code":254,"name":"肯尼亚"},{"code":371,"name":"拉脱维亚"},{"code":266,"name":"莱索托"},{"code":370,"name":"立陶宛"},{"code":352,"name":"卢森堡"},{"code":250,"name":"卢旺达"},{"code":40,"name":"罗马尼亚"},{"code":261,"name":"马达加斯加"},{"code":960,"name":"马尔代夫"},{"code":265,"name":"马拉维"},{"code":223,"name":"马里"},{"code":230,"name":"毛里求斯"},{"code":222,"name":"毛里塔尼亚"},{"code":976,"name":"蒙古"},{"code":373,"name":"摩尔多瓦"},{"code":212,"name":"摩洛哥"},{"code":258,"name":"莫桑比克"},{"code":52,"name":"墨西哥"},{"code":264,"name":"纳米比亚"},{"code":27,"name":"南非"},{"code":505,"name":"尼加拉瓜"},{"code":227,"name":"尼日尔"},{"code":234,"name":"尼日利亚"},{"code":47,"name":"挪威"},{"code":351,"name":"葡萄牙"},{"code":46,"name":"瑞典"},{"code":41,"name":"瑞士"},{"code":503,"name":"萨尔瓦多"},{"code":381,"name":"塞尔维亚"},{"code":232,"name":"塞拉利昂"},{"code":221,"name":"塞内加尔"},{"code":357,"name":"塞浦路斯"},{"code":248,"name":"塞舌尔"},{"code":966,"name":"沙特阿拉伯"},{"code":94,"name":"斯里兰卡"},{"code":421,"name":"斯洛伐克"},{"code":386,"name":"斯洛文尼亚"},{"code":268,"name":"斯威士兰"},{"code":597,"name":"苏里南"},{"code":992,"name":"塔吉克斯坦"},{"code":66,"name":"泰国"},{"code":255,"name":"坦桑尼亚"},{"code":1868,"name":"特立尼达和多巴哥"},{"code":90,"name":"土耳其"},{"code":993,"name":"土库曼斯坦"},{"code":216,"name":"突尼斯"},{"code":502,"name":"危地马拉"},{"code":58,"name":"委内瑞拉"},{"code":673,"name":"文莱"},{"code":256,"name":"乌干达"},{"code":380,"name":"乌克兰"},{"code":598,"name":"乌拉圭"},{"code":998,"name":"乌兹别克斯坦"},{"code":34,"name":"西班牙"},{"code":30,"name":"希腊"},{"code":36,"name":"匈牙利"},{"code":1876,"name":"牙买加"},{"code":967,"name":"也门"},{"code":39,"name":"意大利"},{"code":972,"name":"以色列"},{"code":91,"name":"印度"},{"code":62,"name":"印度尼西亚"},{"code":44,"name":"英国"},{"code":1284,"name":"英属维尔京群岛"},{"code":962,"name":"约旦"},{"code":84,"name":"越南"},{"code":260,"name":"赞比亚"},{"code":235,"name":"乍得"},{"code":56,"name":"智利"}]

export default {
    API_SERVICE_SERVER_BASE_URL,
    API_SERVER_BASE_URL,
    API_NEWS_SERVER_BASE_URL,
    OSS_BASE_URL,
    SOCKET_IO_SERVER,
    SOCKET_PROJECT_CODE,
    ROLE_LIST,
    ICODE_TYPE,
    ROLE_DEVELOPER,
    ROLE_PROJECT_MANAGER,
    ROLE_QUALITY_ASSURANCE,
    ROLE_CUSTOMER,
    Page_Sizes,
    CountryCode
}